import { Input } from "@mui/material";

export const RunNameComponent = (props: {
  name: string;
  setName: (name: string) => void;
  saveName: () => void;
}) => {
  const { name, setName, saveName } = props;
  return (
    <Input
      value={name}
      onChange={(event) => setName(event.target.value)}
      onBlur={() => saveName()}
    />
  );
};
